import { classNames, FlexColumn, Skeleton, SkeletonLine } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { slideClasses } from "@/components/collection/overview/styles";
import { ItemCard, ItemCardContent, ItemCardFooter, ItemCardFooterSection } from "@/components/items/card/ItemCard";
export function FeaturedItemsCarouselSkeleton({
  slides
}) {
  return range(slides).map(index => <ItemCard className={classNames(slideClasses({
    variant: "item"
  }))} key={index}>
      <ItemCardContent>
        <Skeleton className="aspect-1/1 rounded-b-none bg-bg-additional-1" />
      </ItemCardContent>
      <ItemCardFooter className="min-h-24">
        <ItemCardFooterSection className={classNames("h-[calc(theme(spacing.12)+theme(spacing.3))] pt-3")}>
          <SkeletonLine className="h-6 w-1/2" />
        </ItemCardFooterSection>
        <ItemCardFooterSection className="pb-3.5">
          <FlexColumn className="w-full gap-0.5">
            <SkeletonLine className="h-[18px] w-1/4" />
            <SkeletonLine className="h-[18px] w-1/3" />
          </FlexColumn>
        </ItemCardFooterSection>
      </ItemCardFooter>
    </ItemCard>);
}